import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import AddIcon from "@material-ui/icons/Add";
import { FieldArray, Form } from "formik";
import Input from "../../../../components/Input";
import CheckIcon from "@material-ui/icons/Check";
import RemoveIcon from "@material-ui/icons/Remove";
import SettingsBackupRestoreIcon from "@material-ui/icons/SettingsBackupRestore";
import { useIntl } from "react-intl";
import { Grid } from "@material-ui/core";
import MaterialPreview from "../../../../components/MaterialPreview";
import Upload from "../../../../components/Upload";
import { showHideSnackbar } from "../../../../store/Snackbar/actions";
import { useDispatch } from "react-redux";

function QuizAnswerForm({
  mode,
  question,
  questionIndex,
  setFieldValue,
  formRef
}) {
  const { messages } = useIntl();
  const { quizzes } = messages;
  const uploadAnswerRef = useRef();
  const dispatch = useDispatch();
  const setTabValue = (
    setFieldValue,
    questionIndex,
    question,
    type
  ) => {
    const newArray = [];
    question.answer_choices_attributes.forEach((answer) => {
      if (answer?.id) {
        let deletedAns = {
          ...answer,
          correct: false,
          _destroy: true
        };
        newArray.push(deletedAns);
      }
    });

    const withTwoEmptyValues = [
      ...newArray,
      ...[
        {
          answer: "",
          correct: false,
          image_url: "",
          currentTab: type
        },
        {
          answer: "",
          correct: false,
          image_url: "",
          currentTab: type
        }
      ]
    ];

    setFieldValue(
      `questions_attributes[${questionIndex}].answer_choices_attributes`,
      withTwoEmptyValues
    );
  };

  const AddAnswer = (push, question) => {
    return () => {
      push({
        answer: "",
        currentTab: question.answer_choices_attributes[0].currentTab,
        image_url: "",
        correct: false
      });
    };
  };

  const removeAnswer = (replace, answerIndex, answer) => {
    return () => {
      replace(answerIndex, {
        ...answer,
        correct: false,
        _destroy: true
      });
    };
  };

  async function handleUploadSingleImage(e, qIndex, AIndex, type) {
    let file = e?.target?.files[0];
    if (file) {
      if (file?.type?.includes("image")) {
        let url = URL.createObjectURL(file);
        let objFile = { file, url };

        if (type == "answer") {
          formRef.current.setFieldValue(
            `questions_attributes[${qIndex}].answer_choices_attributes[${AIndex}].image_url`,
            objFile
          );
          if (uploadAnswerRef.current)
            uploadAnswerRef.current.value = null;
        }
        // Clear input value
        e.target.value = null;
      } else {
        dispatch(
          showHideSnackbar({
            type: "error",
            isOpen: true,
            message: "Please select image"
          })
        );
      }
    }
  }

  function getCurrentTab(answers) {
    const hasText = answers.some(
      (a) => a.answer && a.answer.trim() !== ""
    );
    const hasImage = answers.some(
      (a) => a.image_url && a.image_url !== ""
    );

    if (hasText && hasImage) {
      console.log("text_image");
      return "text_image";
    }
    if (hasImage) {
      console.log("image");
      return "image";
    }
    if (hasText) {
      console.log("text");
      return "text";
    }

    return "text";
  }
  console.log("mode", mode);

  useEffect(() => {
    if (mode === "edit") {
      const currentTab = getCurrentTab(
        question.answer_choices_attributes
      );

      question.answer_choices_attributes
        .filter((answer) => answer._destroy !== true)
        .forEach((answer, answerIndex) => {
          if (answer.currentTab !== currentTab) {
            setFieldValue(
              `questions_attributes[${questionIndex}].answer_choices_attributes[${answerIndex}].currentTab`,
              currentTab
            );
          }
        });
    }
  }, [
    question.answer_choices_attributes,
    questionIndex,
    setFieldValue,
    mode
  ]);

  return (
    <FieldArray
      name={`questions_attributes[${questionIndex}].answer_choices_attributes`}
    >
      {({ push, replace, remove }) => {
        return (
          <Form>
            <ul className="nav nav-tabs">
              <li className="nav-item" role="presentation">
                <button
                  className={
                    question.answer_choices_attributes[0]
                      ?.currentTab === "text"
                      ? "nav-link active"
                      : "nav-link"
                  }
                  data-bs-toggle="tab"
                  data-bs-target={`#text_${questionIndex}`}
                  type="button"
                  role="tab"
                  aria-controls={`text_${questionIndex}`}
                  aria-selected="false"
                  onClick={() =>
                    setTabValue(
                      setFieldValue,
                      questionIndex,
                      question,
                      "text"
                    )
                  }
                >
                  Text
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button
                  className={
                    question.answer_choices_attributes[0]
                      ?.currentTab === "image"
                      ? "nav-link active"
                      : "nav-link"
                  }
                  data-bs-toggle="tab"
                  data-bs-target={`#image_${questionIndex}`}
                  type="button"
                  role="tab"
                  aria-controls={`image_${questionIndex}`}
                  aria-selected="false"
                  onClick={() =>
                    setTabValue(
                      setFieldValue,
                      questionIndex,
                      question,
                      "image"
                    )
                  }
                >
                  Image
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button
                  className={
                    question.answer_choices_attributes[0]
                      ?.currentTab === "text_image"
                      ? "nav-link active"
                      : "nav-link"
                  }
                  data-bs-toggle="tab"
                  data-bs-target={`#image_text_${questionIndex}`}
                  type="button"
                  role="tab"
                  aria-controls={`image_text_${questionIndex}`}
                  aria-selected="false"
                  onClick={() =>
                    setTabValue(
                      setFieldValue,
                      questionIndex,
                      question,
                      "text_image"
                    )
                  }
                >
                  Image with Text
                </button>
              </li>
            </ul>

            <div className="tab-content py-4" id="myTabContent">
              <div
                className={
                  getCurrentTab(
                    question.answer_choices_attributes
                  ) === "text"
                    ? "tab-pane fade show active"
                    : "tab-pane fade"
                }
                id={`text_${questionIndex}`}
                role="tabpanel"
                aria-labelledby={`text_${questionIndex}`}
              >
                {question.answer_choices_attributes.map(
                  (answer, answerIndex, arr) => {
                    return (
                      !answer._destroy && (
                        <div
                          className="mx-5 d-flex"
                          key={JSON.stringify(answerIndex)}
                        >
                          <div className="flex-fill">
                            <Input
                              name={`questions_attributes[${questionIndex}].answer_choices_attributes[${answerIndex}].answer`}
                              label={quizzes?.answer}
                              isRequired={true}
                            />
                          </div>
                          <div className="mx-2">
                            {arr?.filter((x) => !x._destroy)[0] && (
                              <div className="d-flex">
                                <AddIcon
                                  className="me-2 mt-2 cursor-pointer"
                                  onClick={() => {
                                    push({
                                      answer: "",
                                      currentTab:
                                        question
                                          .answer_choices_attributes[0]
                                          .currentTab,
                                      image_url: "",
                                      correct: false
                                    });
                                  }}
                                />
                                {}
                                <div className="mx-2 mt-2 cursor-pointer">
                                  {question.answer_choices_attributes.every(
                                    (el) => el.correct === false
                                  ) === true ? (
                                    <CheckIcon
                                      color="success"
                                      className="me-2"
                                      onClick={() => {
                                        replace(answerIndex, {
                                          ...answer,
                                          correct: true
                                        });
                                      }}
                                    />
                                  ) : (
                                    question
                                      .answer_choices_attributes[
                                      answerIndex
                                    ].correct === true && (
                                      <SettingsBackupRestoreIcon
                                        onClick={() => {
                                          replace(answerIndex, {
                                            ...answer,
                                            correct: false
                                          });
                                        }}
                                      />
                                    )
                                  )}
                                </div>
                              </div>
                            )}
                          </div>

                          {question.answer_choices_attributes.filter(
                            (x) => !x._destroy
                          ).length > 2 && (
                            <div className="mx-2 mt-2 cursor-pointer">
                              <RemoveIcon
                                className="me-2"
                                onClick={() => {
                                  if (!answer.id) {
                                    remove(answerIndex);
                                    return;
                                  }
                                  replace(answerIndex, {
                                    ...answer,
                                    answer: "deleted",
                                    correct: false,

                                    _destroy: true
                                  });
                                }}
                              />
                            </div>
                          )}
                        </div>
                      )
                    );
                  }
                )}
              </div>

              <div
                className={
                  getCurrentTab(
                    question.answer_choices_attributes
                  ) === "image"
                    ? "tab-pane fade show active"
                    : "tab-pane fade"
                }
                id={`image_${questionIndex}`}
                role="tabpanel"
                aria-labelledby={`image_${questionIndex}`}
              >
                {question.answer_choices_attributes.map(
                  (answer, answerIndex, arr) => {
                    return (
                      !answer._destroy && (
                        <div
                          className="mx-5 d-flex"
                          key={JSON.stringify(answerIndex)}
                        >
                          <div className="flex-fill">
                            <Grid item xs={6} className="pb-0">
                              <div className="d-flex flex-column align-items-center text-center">
                                <div className="mb-3 d-flex flex-column align-items-center w-100">
                                  <MaterialPreview
                                    type={1}
                                    isPublic={false}
                                    src={
                                      answer.image_url?.url
                                        ? answer.image_url?.url
                                        : answer.image_url
                                    }
                                    hasClear={true}
                                    onClear={() => {
                                      setFieldValue(
                                        `questions_attributes[${questionIndex}].answer_choices_attributes[${answerIndex}].image_url`,
                                        ""
                                      );
                                    }}
                                  />
                                </div>

                                <Upload
                                  ref={uploadAnswerRef}
                                  onChange={(e) =>
                                    handleUploadSingleImage(
                                      e,
                                      questionIndex,
                                      answerIndex,
                                      "answer"
                                    )
                                  }
                                  label={quizzes?.upload}
                                  name={`questions_attributes[${questionIndex}].answer_choices_attributes[${answerIndex}].image_url`}
                                  accept="image/*"
                                  isImage={true}
                                  setFieldValue={setFieldValue}
                                  isRequired={true}
                                  isMultiple={false}
                                />
                              </div>
                            </Grid>
                          </div>
                          <div className="mx-2">
                            {arr?.filter((x) => !x._destroy)[0] && (
                              <div className="d-flex">
                                <AddIcon
                                  className="me-2 mt-2 cursor-pointer"
                                  onClick={() => {
                                    push({
                                      answer: "",
                                      currentTab:
                                        question
                                          .answer_choices_attributes[0]
                                          .currentTab,
                                      image_url: "",
                                      correct: false
                                    });
                                  }}
                                />
                                <div className="mx-2 mt-2 cursor-pointer">
                                  {question.answer_choices_attributes.every(
                                    (el) => el.correct === false
                                  ) === true ? (
                                    <CheckIcon
                                      color="success"
                                      className="me-2"
                                      onClick={() => {
                                        replace(answerIndex, {
                                          ...answer,
                                          correct: true
                                        });
                                      }}
                                    />
                                  ) : (
                                    question
                                      .answer_choices_attributes[
                                      answerIndex
                                    ].correct === true && (
                                      <SettingsBackupRestoreIcon
                                        onClick={() => {
                                          replace(answerIndex, {
                                            ...answer,
                                            correct: false
                                          });
                                        }}
                                      />
                                    )
                                  )}
                                </div>
                              </div>
                            )}
                          </div>
                          {question.answer_choices_attributes.filter(
                            (x) => !x._destroy
                          ).length > 2 && (
                            <div className="mx-2 mt-2 cursor-pointer">
                              <RemoveIcon
                                className="me-2"
                                onClick={() =>
                                  replace(answerIndex, {
                                    ...answer,
                                    correct: false,

                                    _destroy: true
                                  })
                                }
                              />
                            </div>
                          )}
                        </div>
                      )
                    );
                  }
                )}
              </div>
              <div
                className={
                  getCurrentTab(
                    question.answer_choices_attributes
                  ) === "text_image"
                    ? "tab-pane fade show active"
                    : "tab-pane fade"
                }
                id={`image_text_${questionIndex}`}
                role="tabpanel"
                aria-labelledby={`image_text_${questionIndex}`}
              >
                {question.answer_choices_attributes.map(
                  (answer, answerIndex, arr) => {
                    return (
                      !answer._destroy && (
                        <div
                          className="mx-5 d-flex"
                          key={JSON.stringify(answerIndex)}
                        >
                          <div className="flex-fill">
                            <Input
                              name={`questions_attributes[${questionIndex}].answer_choices_attributes[${answerIndex}].answer`}
                              label={quizzes?.answer}
                              isRequired={true}
                            />
                            <div className="flex-fill">
                              <Grid item xs={6} className="pb-0">
                                <div className="d-flex flex-column align-items-center text-center">
                                  <div className="mb-3 d-flex flex-column align-items-center w-100">
                                    <MaterialPreview
                                      type={1}
                                      isPublic={false}
                                      src={
                                        answer.image_url?.url
                                          ? answer.image_url?.url
                                          : answer.image_url
                                      }
                                      hasClear={true}
                                      onClear={() => {
                                        setFieldValue(
                                          `questions_attributes[${questionIndex}].answer_choices_attributes[${answerIndex}].image_url`,
                                          ""
                                        );
                                      }}
                                    />
                                  </div>
                                  <Upload
                                    ref={uploadAnswerRef}
                                    onChange={(e) =>
                                      handleUploadSingleImage(
                                        e,
                                        questionIndex,
                                        answerIndex,
                                        "answer"
                                      )
                                    }
                                    label={quizzes?.upload}
                                    name={`questions_attributes[${questionIndex}].answer_choices_attributes[${answerIndex}].image_url`}
                                    accept="image/*"
                                    isImage={true}
                                    setFieldValue={setFieldValue}
                                    isRequired={true}
                                    isMultiple={false}
                                  />
                                </div>
                              </Grid>
                            </div>
                          </div>
                          <div className="mx-2">
                            {arr?.filter((x) => !x._destroy)[0] && (
                              <div className="d-flex">
                                <AddIcon
                                  className="me-2 mt-2 cursor-pointer"
                                  onClick={AddAnswer(
                                    push,
                                    question,
                                    questionIndex
                                  )}
                                />
                                <div className="mx-2 mt-2 cursor-pointer">
                                  {question.answer_choices_attributes.every(
                                    (el) => el.correct == false
                                  ) === true ? (
                                    <CheckIcon
                                      color="success"
                                      className="me-2"
                                      onClick={() => {
                                        replace(answerIndex, {
                                          ...answer,
                                          correct: true
                                        });
                                      }}
                                    />
                                  ) : (
                                    question
                                      .answer_choices_attributes[
                                      answerIndex
                                    ].correct === true && (
                                      <SettingsBackupRestoreIcon
                                        onClick={() => {
                                          replace(answerIndex, {
                                            ...answer,
                                            correct: false
                                          });
                                        }}
                                      />
                                    )
                                  )}
                                </div>
                              </div>
                            )}
                          </div>
                          {question.answer_choices_attributes.filter(
                            (x) => !x._destroy
                          ).length > 2 && (
                            <div className="mx-2 mt-2 cursor-pointer">
                              <RemoveIcon
                                className="me-2"
                                onClick={removeAnswer(
                                  replace,
                                  answerIndex,
                                  answer
                                )}
                              />
                            </div>
                          )}
                        </div>
                      )
                    );
                  }
                )}
              </div>
            </div>
          </Form>
        );
      }}
    </FieldArray>
  );
}

QuizAnswerForm.propTypes = {
  mode: PropTypes.string.isRequired,
  question: PropTypes.object.isRequired,
  questionIndex: PropTypes.number.isRequired,
  setFieldValue: PropTypes.func.isRequired,
  formRef: PropTypes.object.isRequired
};

export default QuizAnswerForm;
